import { useSelector } from "react-redux";

import { type LeadsSearchRowWithKey, selectExpandedRowKeys } from "app/pages/sales-intelligence/modules/leads-search";
import { selectExpandedRowVariant } from "app/pages/sales-intelligence/modules/leads-search/store/selectors";
import { is } from "app/pages/sales-intelligence/utils/type-guards";

import type { LeadsSearchColumnListConfig } from "../../../types";
import { getLeadDomainFromRow } from "../../../utils/rows";
import CrmRecordsTableContainer from "../CrmRecordsTable/CrmRecordsTableContainer";
import DomainsSearchResultsTableContainer from "../DomainsSearchResultsTable/DomainsSearchResultsTableContainer";

type Props<R extends LeadsSearchRowWithKey> = {
    record: R;
    columnsConfig: LeadsSearchColumnListConfig;
};

const ExpandedRowContainer = <R extends LeadsSearchRowWithKey>({ record, columnsConfig }: Props<R>) => {
    const expandedRowKeys = useSelector(selectExpandedRowKeys);
    const expandedRowVariant = useSelector(selectExpandedRowVariant);

    const domain = getLeadDomainFromRow(record);

    if (!expandedRowKeys.includes(record.key) || !is.nonEmptyString(domain)) {
        return null;
    }

    if (expandedRowVariant?.kind === "crm-records") {
        return (
            <CrmRecordsTableContainer
                record={record}
                domain={domain}
                integrationProvider={expandedRowVariant.integrationProvider}
            />
        );
    }
    return (
        <DomainsSearchResultsTableContainer
            record={record}
            domain={domain}
            columnsConfig={columnsConfig}
        />
    );
};

export default ExpandedRowContainer;
